import React from 'react';
import {connect} from 'react-redux';
import { setActivitiesOpen, setLinks} from '../../../../actions/create-action';


import { store } from '../../../../store';

const mapStateToProps = (state) => {

  let links = state.links;
  let activities = state.activities;

  return {
    links: links,
    activities: activities,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLinks: (links) => dispatch(setLinks(links)),
    onOpen: (open) => dispatch(setActivitiesOpen(open))
  }
}

  const initialstate = {
    flag:false,
 
//link section
    selectValue:'',
    textboxvalue:'',
    addlink: false
  };

class LinksFunction extends React.Component {
  constructor(props){
    super(props)
    this.state = initialstate
  }
  handledropdownChange = (e) => {
    this.setState({selectValue:e.target.value});

  }

  handletextboxChange = (e, link) => {
    this.setState({textboxvalue: e.target.value});
  }

 handlelinkchange = (e, links) =>                             
  {
    let {textboxvalue, selectValue} = this.state
    let split = 0
    if(selectValue === 'envelope') {
      textboxvalue = 'mailto:' + textboxvalue
      split = 1
    }
    else if (textboxvalue.substring(0,7) !== 'http://' && textboxvalue.substring(0,8) !== 'https://') 
    {
      textboxvalue = 'https://' + textboxvalue
      split = 1
    }
    else
    {
      split = 1
    }
    if(split)
    {
      let newLink= {
            name: selectValue,
            link : textboxvalue
          }
      let flag=0;
      if(selectValue === '' || textboxvalue === '')
      {
          this.setState({error: 'empty'})
      }
      else if(store.getState().links === null)
      {
          this.props.onLinks(newLink)
          this.setState(initialstate)
      }
      else
      {
        let arr = store.getState().links;
        for(let i=0; i<arr.length; i++)
        {
          if(arr[i].name === selectValue )
          {
             arr[i].link = textboxvalue;
             this.props.onLinks(arr)
             this.setState(initialstate)
             flag = 1;
          }
          this.setState({error: 'duplicateLink'});
        }
        if(flag === 0)
        {
          let newconcatedlink = store.getState().links.concat(newLink);
          this.props.onLinks(newconcatedlink)
          this.setState(initialstate)
        }
      }
      this.props.onOpen('')
      }
  }
  handleaddbutton = (e) => {
      this.setState({addlink: true})
  }
  render() {
    let OnArray = null
    const _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handlelinkchange()
      }
    }
    if(store.getState().activities.open === 'links')
      return (
    <div className={this.props.alignCenter === 'true' ? "social_settings social_settings_center" : "social_settings"}>
    <div className="social_insider"
    onMouseOver={this.props.onClickInside.bind()}
    onMouseOut={this.props.onClickOutside.bind()}
    onKeyDown={_handleKeyPress}>
    <select className="create_inp"
                  onChange={this.handledropdownChange}> 
                    <option disabled selected>Select</option>
                    <option value="facebook">Facebook</option>
                    <option value="github">Github</option>
                    <option value="medium">Medium</option>
                    <option value="instagram">Instagram</option>
                    <option value="twitch">Twitch</option>
                    <option value="twitter">Twitter</option>
                    <option value="linkedin">LinkedIn</option>
                    <option value="angellist">Angel list</option>
                    <option value="pinterest">Pinterest</option>
                    <option value="product-hunt">ProductHunt</option>
                    <option value="youtube">Youtube</option>
                    <option value="telegram">Telegram</option>
                    <option value="slack">Slack</option>
                    <option value="wordpress">Wordpress</option>
                    <option value="tumblr">Tumblr</option>
                    <option value="reddit">Reddit</option>
                    <option value="map">Nomad List</option>
                    <option value="dribbble">Dribbble</option>
                    <option value="behance">Behance</option>
                    <option value="globe">Website link</option>
                    <option value="envelope">Mail</option>
              </select><br /><br />
              <input placeholder="eg: http://fb.com/yourusername"
              className="create_inp"
              type='text' onChange={this.handletextboxChange}/>
              <button className="top_btn white_btn" onClick={this.handlelinkchange}>Add</button>
    </div>
    <div className="social_insider_arrow" />
    </div>
     )  
    else {
    let arr = store.getState().links
    OnArray = arr.map((value,i) => {
    if(store.getState().activities.open === value.name) {
      if(this.state.textboxvalue !== value.link && this.state.selectValue !== value.name) {
      this.setState({
        textboxvalue: value.link,
        selectValue: value.name
      })
      }
      return (<div className={this.props.alignCenter === 'true' ? "social_settings social_settings_center" : "social_settings"}>
    <div className="social_insider"
    onMouseOver={this.props.onClickInside.bind()}
    onMouseOut={this.props.onClickOutside.bind()}
    onKeyDown={_handleKeyPress}>
    <select className="create_inp" disabled >
                  <option> {value.name} </option>
                </select>
              <input
              className="create_inp"
              placeholder={value.link}
              value={this.state.textboxvalue}
              type='text' onChange={this.handletextboxChange}/>
              <span href="#" className="close close_social" id={i} onClick = {(e,links) =>{
                    let clickedid = e.target.id;
                    arr.splice(clickedid,1);
                    this.props.onLinks(arr);
                    this.props.onOpen('');
                }} />
              <button className="top_btn white_btn" onClick={this.handlelinkchange}>Done</button>
    </div>
    <div className="social_insider_arrow" />
              </div>)
    }
    else
    {
      return null
    }
    })

  }
    return OnArray
}
}
export default connect(mapStateToProps, mapDispatchToProps)(LinksFunction)
